var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders,
    typography = _ref.typography,
    transitions = _ref.transitions;
  return {
    attachQuestionButtonHolderZIndex: '2222',
    newItemButtonMargin: spacing.xSmall,
    newItemButtonPadding: spacing.xSmall,
    newItemButtonBackgroundColor: colors.contrasts.blue4570,
    newItemButtonBorderRadius: spacing.large,
    newItemButtonColor: colors.contrasts.white1010,
    newItemButtonFocusOutline: "2px solid ".concat(colors.contrasts.blue4570),
    newItemButtonFocusOutlineOffset: spacing.xxxSmall,
    newItemButtonFontSize: typography.fontSizeMedium,
    newItemButtonFontWeight: typography.fontWeightBold,
    newItemButtonZIndex: '4444',
    newItemButtonBoxShadow: '2px 2px 3px #ddd',
    newItemButtonEditingBackgroundColor: colors.contrasts.red4570,
    newItemButtonHolderZIndex: '2222',
    newItemButtonTransition: "background-color ".concat(transitions.duration, " linear, transform ").concat(transitions.duration, " ease")
  };
};
export default generateComponentTheme;